import options from './save-view.directive';

const Directive = {
    selector: 'dtSaveView',
    options
};

export {
    Directive
};



// WEBPACK FOOTER //
// ./app/common/save-view/index.js